import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=2d31cc42&scoped=true&"
import script from "./PaymentInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=2d31cc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31cc42",
  null
  
)

export default component.exports